import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import JwtService from '@/core/services/jwt.service'

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = process.env.VUE_APP_HTTP || 'https://panel-32f4fa75a990e4cf9847709ece97bcfe.go.vpnlabel.net/api'
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${JwtService.getToken()}`
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch((error) => {
      throw new Error(`[KT] ApiService ${error}`)
    })
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param queries
   * @returns {*}
   */
  get(resource, queries, config = {}) {
    const params = new URLSearchParams()
  
    if (queries) {
      for (const key in queries) {
        if (queries[key] !== undefined) {
          params.append(key, queries[key])
        }
      }
    }
  
    const queryString = params.toString()
    const fullUrl = `${resource}${queryString ? '?' + queryString : ''}`
  
    // Merge the config object with the necessary URL and query parameters
    return Vue.axios.get(fullUrl, { ...config })
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    return Vue.axios.post(`${resource}`, params)
  },

  /**
   * Set the PATCH HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  patch(resource, params) {
    return Vue.axios.patch(`${resource}`, params)
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params)
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params)
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource)
  },
}

export default ApiService
